import React, { useState, useEffect } from "react";
import { Button, Input, Select, Textarea } from "../Form";
import { BiChevronDown } from "react-icons/bi";
import { toast } from "react-hot-toast";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl";
import { TbBrandWhatsapp } from "react-icons/tb";

const sendToData = [
  { id: 1, name: "All Patients", value: "All Patients" },
  { id: 2, name: "NHCF Patients", value: "NHCF Patients" },
  { id: 3, name: "Britam Patients", value: "Britam Patients" },
];

function WhatsappComp({ data, onSuccess, closeModal }) {
  const isViewMode = !!data?._id;

  const [sendTo, setSendTo] = useState(sendToData[0]);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isViewMode) {
      setSendTo(
        sendToData.find((d) => d.value === data.sendTo) || sendToData[0]
      );
      setTitle(data.title || "");
      setMessage(data.message || "");
    }
  }, [data, isViewMode]);

  const handleSend = async () => {
    if (!title || !message) {
      toast.error("Please fill in Title and Message");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        title,
        type: "whatsapp",
        message,
        sendTo: sendTo.value,
      };

      const response = await axios.post(
        `${BaseUrl}/facility/campaigns`,
        payload,
        {
          withCredentials: true,
        }
      );

      if (response.data.success) {
        toast.success("WhatsApp Campaign Sent Successfully!");
        if (onSuccess) onSuccess();
        if (closeModal) closeModal();
      }
    } catch (error) {
      console.error("Error sending WhatsApp campaign:", error);
      toast.error(error.response?.data?.message || "Failed to send WhatsApp");
    } finally {
      setLoading(false);
    }
  };

  // View Mode
  if (isViewMode) {
    return (
      <div className='mt-6 flex w-full flex-col gap-6'>
        {/* Campaign Header */}
        <div className='flex items-center gap-4 border-b border-border pb-4'>
          <div className='flex h-14 w-14 items-center justify-center rounded-full bg-green-100 text-green-500'>
            <TbBrandWhatsapp className='text-2xl' />
          </div>
          <div>
            <h3 className='text-lg font-semibold'>{data.title}</h3>
            <p className='text-sm text-gray-500'>WhatsApp Campaign</p>
          </div>
          <span
            className={`ml-auto rounded-full px-3 py-1 text-xs font-medium ${
              data.status === "Sent"
                ? "bg-green-100 text-green-600"
                : "bg-gray-100 text-gray-600"
            }`}
          >
            {data.status}
          </span>
        </div>

        {/* Details Grid */}
        <div className='grid grid-cols-2 gap-4'>
          <div>
            <p className='text-xs text-gray-400'>Send To</p>
            <p className='font-medium'>{data.sendTo}</p>
          </div>
          <div>
            <p className='text-xs text-gray-400'>Date Sent</p>
            <p className='font-medium'>{data.date || "N/A"}</p>
          </div>
        </div>

        {/* Message */}
        <div>
          <p className='mb-2 text-xs text-gray-400'>Message</p>
          <div className='rounded-lg border border-border bg-green-50 p-4'>
            <p className='whitespace-pre-wrap text-sm text-gray-700'>
              {data.message}
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Create Mode
  return (
    <div className='mt-4 flex w-full flex-col gap-4'>
      <Input
        label='Campaign Title'
        color={true}
        placeholder='Enter campaign title'
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <div className='flex w-full flex-col gap-3'>
        <p className='text-sm'>Send To</p>
        <Select
          selectedPerson={sendTo}
          setSelectedPerson={setSendTo}
          datas={sendToData}
        >
          <div className='flex h-14 w-full items-center justify-between rounded-md border border-border bg-white px-4 text-xs text-main'>
            <p>{sendTo?.name}</p>
            <BiChevronDown className='text-xl' />
          </div>
        </Select>
      </div>

      <Textarea
        label='Message'
        placeholder='Type WhatsApp message...'
        color={true}
        rows={5}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />

      <Button
        label={loading ? "Sending..." : "Send Campaign"}
        onClick={handleSend}
        disabled={loading}
      />
    </div>
  );
}

export default WhatsappComp;
